import { StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  container: {
    marginBottom: 100,
  },
  stepTitle: {
    fontSize: Fonts.size.h4,
    marginVertical: 15,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  },
  stepDescription: theme => ({
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorTwo,
  }),
  titleOfferStyle: {
    fontSize: Fonts.size.h5,
    ...Fonts.type.bold,
  },
  offerCardStyle: {
    marginHorizontal: 0,
    marginTop: 20,
  },
  cardContentContainer: {
    paddingVertical: 0,
    borderWidth: 0,
  },
  cardStyle: {
    marginBottom: 30,
    
  },
  modal: {
    margin: 0,
  },
  modalContentContainer: theme => ({
    flex: 1,
    backgroundColor: theme.colors.cardBackgroundColor,
    justifyContent: 'center',
    
  }),
})

export default styles
